// Module
import './menu.js';
import './css.js';

// Utility functions
const $ = selector => document.querySelector(selector);
const $$ = selector => Array.from(document.querySelectorAll(selector));

// Plugins
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger,SplitText);

// Initialize when DOM is ready
window.addEventListener('DOMContentLoaded', () => {
  // Add smooth scroll behavior to all internal links
  $$('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = $(link.getAttribute('href'));
      if (target) {
        const easing = t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        const start = window.pageYOffset;
        const end = target.getBoundingClientRect().top + start;
        const duration = 400;
        const startTime = performance.now();

        function animate(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          window.scrollTo(0, start + (end - start) * easing(progress));
          
          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        }
        
        requestAnimationFrame(animate);
        return;
      }
    });
  });

  // =====================
  // Accordion
  // =====================
  $$('[data-accordion]').forEach(accordion => {
    const button = accordion.querySelector('[data-accordion-button]');
    const contents = accordion.querySelector('[data-accordion-contents]');
    
    if (!button || !contents) return;

    button.addEventListener('click', () => {
      accordion.classList.toggle('open');
    });
  });
});

window.addEventListener('load', () => {

  const ENABLE_SPLIDE = true;
  if (!ENABLE_SPLIDE) return;

  // =====================
  // FV
  // =====================
  const fvSlideTop = document.querySelector('#fvSlideTop');
  if (fvSlideTop) {
    new Splide(fvSlideTop, {
      autoWidth: true,
      type: 'loop',
      arrows: false,
      pagination: false,
      drag: 'free',
      gap: '0.97vh',
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          gap: '1.2vh',
          autoScroll: {
            speed: 0.3,
          },
        },
      },
    }).mount({ AutoScroll });
  }

  const fvSlideBottom = document.querySelector('#fvSlideBottom');
  if (fvSlideBottom) {
    new Splide(fvSlideBottom, {
      autoWidth: true,
      type: 'loop',
      arrows: false,
      pagination: false,
      drag: 'free',
      direction: 'rtl',
      gap: '0.97vh',
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          gap: '1.2vh',
          autoScroll: {
            speed: 0.3,
          },
        },
      },
    }).mount({ AutoScroll });
  }

  // =====================
  // works
  // =====================
  document.querySelectorAll('.works-splide').forEach((worksSlide) => {
    const controls = worksSlide.querySelector('.slider__controls');
    if (!controls) return;
  
    const prev = controls.querySelector('.slider__arrow--prev');
    const next = controls.querySelector('.slider__arrow--next');
  
    const splide = new Splide(worksSlide, {
      type: 'loop',
      // autoplay: true,
      interval: 4000,
      speed: 1200,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      gap: "1.25rem",
      autoWidth: true,
      focus: 'center',
      pagination: true,
      breakpoints: {
        768: {
          gap: "0.8rem",
        },
      },
    }).mount();
  
    /* ============================
       active 更新
    ============================ */
  
    // const update = () => {
    //   const index = splide.index;
    //   buttons.forEach((btn, i) => {
    //     btn.classList.toggle('is-active', i === index);
    //   });
    // };
  
    // update();
    // splide.on('move', update);
  
    /* ============================
       矢印
    ============================ */
  
    prev?.addEventListener('click', () => {
      splide.go('<');
      splide.Components.Autoplay.play();
    });
  
    next?.addEventListener('click', () => {
      splide.go('>');
      splide.Components.Autoplay.play();
    });
  });
  
  
  // =====================
  // Another
  // =====================
  document.querySelectorAll('.another-splide').forEach((anotherSlide) => {
    const controls = anotherSlide.querySelector('.slider__controls');
    if (!controls) return;
  
    // const pagination = controls.querySelector('.slider__pagination');
    const prev = controls.querySelector('.slider__arrow--prev');
    const next = controls.querySelector('.slider__arrow--next');
  
    const splide = new Splide(anotherSlide, {
      type: 'fade',
      autoplay: true,
      interval: 4000,
      speed: 1200,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      pagination: true,
      rewind: true,
    }).mount();
  
    /* ============================
       矢印
    ============================ */
  
    prev?.addEventListener('click', () => {
      splide.go('<');
      splide.Components.Autoplay.play();
    });
  
    next?.addEventListener('click', () => {
      splide.go('>');
      splide.Components.Autoplay.play();
    });
  });
  

  // =====================
  // sub
  // =====================
  document.querySelectorAll('.sub-splide').forEach((el) => {
    new Splide(el, {
      type: 'loop',
      speed: 800,
      perPage: 3,
      perMove: 1,
      gap: '1.8rem',
      pagination: false,
      breakpoints: {
        768: {
          perPage: 2,
          gap: '16px',
        },
      },
    }).mount();
  });

  // =====================
  // Exhibitions
  // =====================
  document.querySelectorAll('.ex-main-splide').forEach((mainEl) => {
    const thumbEl = mainEl.nextElementSibling;
    if (!thumbEl?.classList.contains('ex-thumb-splide')) return;
  
    const prev = mainEl.querySelector('.slider__arrow--prev');
    const next = mainEl.querySelector('.slider__arrow--next');
    const currentEl = mainEl.querySelector('.js-current');
    const totalEl = mainEl.querySelector('.js-total');
    const pages = mainEl.querySelectorAll('.slider__page');
  
    const main = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: false,
      speed: 800,
    });
  
    const thumbs = new Splide(thumbEl, {
      isNavigation: true,
      arrows: false,
      pagination: false,
      drag: false,
      perPage: 999,
      gap: 10,
    });
  
    // 同期
    main.sync(thumbs);
  
    main.mount();
    thumbs.mount();
  
    // 総数
    totalEl.textContent = String(main.length).padStart(2, '0');
  
    // カウンター更新
    const updateCounter = () => {
      currentEl.textContent = String(main.index + 1).padStart(2, '0');
    };
  
    // ページネーション active 切替
    const updatePagination = () => {
      pages.forEach((btn) => {
        btn.classList.toggle(
          'is-active',
          Number(btn.dataset.exSlider) === main.index
        );
      });
    };
  
    const updateAll = () => {
      updateCounter();
      updatePagination();
    };
  
    updateAll();
    main.on('mounted move', updateAll);
  
    // 矢印
    prev?.addEventListener('click', () => main.go('<'));
    next?.addEventListener('click', () => main.go('>'));
  
    // ページネーション操作
    pages.forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = Number(btn.dataset.exSlider);
        main.go(index);
      });
    });
  });   
});
